/* eslint-disable import/prefer-default-export */
import { css } from 'styled-components'
// @ts-ignore
import { basicColor } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'

const ScrollbarStyle = css<{ $mode: Theme }>`
  scrollbar-color: ${({ $mode }) => ($mode === 'dark' ? basicColor.GRAY_800 : '#8F9BA3')}
    transparent;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-corner {
    display: none;
  }
  ::-webkit-scrollbar-thumb:horizontal {
    background-color: ${({ $mode }) => ($mode === 'dark' ? basicColor.GRAY_800 : '#8F9BA3')};
    border-radius: 3px;
  }
  ::-webkit-scrollbar-thumb:horizontal:hover {
    background-color: ${({ $mode }) =>
      $mode === 'dark' ? basicColor.GRAY_700 : basicColor.GRAY_800};
  }
  ::-webkit-scrollbar-thumb:vertical {
    background-color: ${({ $mode }) => ($mode === 'dark' ? basicColor.GRAY_800 : '#8F9BA3')};
    border-radius: 3px;
  }
  ::-webkit-scrollbar-thumb:vertical:hover {
    background-color: ${({ $mode }) =>
      $mode === 'dark' ? basicColor.GRAY_700 : basicColor.GRAY_800};
  }
`

export default ScrollbarStyle
